<template>
    <header class="header position--fixed display--flex background--green color--white shadow--default">
        <div class="header__logo display--flex">
            <router-link class="header__logo__anchor position--relative display--block accessibility--pseudo accessibility--active" to="/">
                <img
                    :src="require('@/assets/images/logo.svg')"
                    alt="Gocc"
                    class="header__logo__image"
                    aria-label="Gocc"
                />
            </router-link>
            <slot name="search-bar" />
        </div>
        <header-profile />
    </header>
</template>

<script>
export default {
    components: {
        HeaderProfile: () => import( /* webpackChunkName: 'HeaderProfile' */ '@/components/bundles/layout/header/HeaderProfile' )
    }
};
</script>

<style lang="scss">
    // =============================================================================
    // Animations
    // =============================================================================
    $dropClass: '.header__profile__dropdown';

    // =============================================================================
    // Animations
    // =============================================================================
    @include keyframes ( fadeInDown ) {
        0% {
            opacity: 0;
            @include transform( translate3d( 0, -10%, 0 ) );
        }
        65% {
            @include transform( none );
        }
        100% {
            opacity: 1;
        }
    }

    @include keyframes ( fadeOutUp ) {
        0% {
            opacity: 1;
        }
        85% {
            opacity: 0;
        }
        100% {
            @include transform( translate3d( 0, -10%, 0 ) );
        }
    }

    // =============================================================================
    // Style
    // =============================================================================
    .header {
        @include transform-position( 0, false, false, 0 );
        align-items: center;
        justify-content: space-between;
        @include dimensions( 100%, $header-height );
        @include typography-specs( 22px, 29px );
        padding: 0 26px;
        z-index: 998;
        @include responsive( max-width, 1380px ) {
            @include typography-specs( 16px, 20px );
        }
        &__logo {
            &__anchor {
                @include dimensions( 53px, 53px );
                &:focus {
                    &::before {
                        border: 2px dashed $color-yellow;
                        @include rounded-corner( 50% );
                    }
                }
            }
        }
        &__profile {
            align-items: center;
            &:focus {
                & .avatar {
                    &::before {
                        @include pseudo();
                        @include transform-position( -2px, false, false, -2px );
                        @include dimensions( 100%, 100% );
                        border: 2px dashed $color-yellow;
                        @include rounded-corner( 50% );
                    }
                }
            }
            &:focus-within #{$dropClass} {
                display: block;
                opacity: 1;
                -webkit-animation: fadeInDown .6s ease-in-out;
                animation: fadeInDown .6s ease-in-out;
                &__option {
                    &__anchor {
                        &:focus-within {
                            outline: 2px dashed $color-green;
                            outline-offset: 1px;
                        }
                        &:active:hover {
                            visibility: hidden;
                            & > * {
                                visibility: visible;
                            }
                        }
                    }
                }
            }
            &__avatar {
                @include dimensions( 53px, 53px );
                margin-left: 35px;
                @include transition( transform .2s ease-in-out );
                &:hover {
                    @include transform( scale( .95 ) );
                }
                @include responsive( max-width, 1380px ) {
                    margin-left: 0;
                }
            }
            &__dropdown {
                @include transform-position( $header-height, false, false, calc( 100% - 211px + 24px ) );
                width: 211px;
                padding: 20px 0 0 30px;
                &.js-active {
                    opacity: 1;
                    animation: fadeInDown .6s ease-in-out;
                }
                &.js-inactive {
                    animation: fadeOutUp .6s ease-in-out;
                }
                &__option {
                    height: 40px;
                    &:hover {
                        color: $color-dark;
                    }
                    &--active {
                        color: $color-green;
                    }
                }
            }
        }
    }
</style>